import useCompetitionGenderMultiSelect from './UseCompetitionGenderMultiSelect';

import MultiSelect from '../MultiSelect';

import global from '../../GlobalStyle.module.css';

const CompetitionGenderMultiSelect = ({ label, name, value, error, message, onChange }) => {
  const { competitionGenderState, options } = useCompetitionGenderMultiSelect();

  return competitionGenderState.message
    ? <span className={global.LoadingMsg}>{competitionGenderState.message}</span>
    : (
      <MultiSelect
        label={label}
        name={name}
        value={value}
        options={options}
        error={error}
        message={message}
        isLoading={competitionGenderState.isLoading}
        onChange={onChange} />
    );
};

export default CompetitionGenderMultiSelect;